// src/routes/Router.tsx
import { Routes, Route } from 'react-router-dom';
import Main from '@/pages/Main';
import AdjusterIntro from '@/pages/AdjusterIntro';
import LatestNews from '@/pages/LatestNewsIntro';
import About from '@/pages/About';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import NoticeDetail from '@/pages/NoticeDetail';
import AdjusterDetailPage from '@/pages/AdjusterDetailPage';
import Faq from '@/pages/FaqIntro';
import FaqDetail from '@/pages/FaqDetail';
import AuthCallback from '@/pages/AuthCallback';
import AppointmentPage from '@/pages/appointment';
import Success from '@/pages/Success';
// import YouTube from '@/components/mo/Youtube';
import ReviewPage from '@/pages/Reviews';
import ReviewDetailPage from '@/pages/Reviews/ReviewDetailPage';

const Router = () => {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/" element={<Main />} />
      <Route path="/allbadeum" element={<Main />} />
      <Route path="/intro/adjusters" element={<AdjusterIntro />} />
      <Route path="/intro/adjusters/:id" element={<AdjusterDetailPage />} />
      <Route path="/intro/news" element={<LatestNews />} />
      <Route path="/intro/news/:id" element={<NoticeDetail />} />
      <Route path="/intro/Faq" element={<Faq />} />
      <Route path="/intro/Faq/:id" element={<FaqDetail />} />
      <Route path="/intro/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/appointment" element={<AppointmentPage />} />
      <Route path="/appointment/success" element={<Success />} />
      <Route path="/review" element={<ReviewPage />} />
      <Route path="/review/:id" element={<ReviewDetailPage />} />
      {/* <Route path="/youtube" element={<YouTube />} /> */}
      {/* <Route path="/ApplyAssign" element={<ApplyAssign />} /> */}
    </Routes>
  );
};

export default Router;
